import { Tab, TabProps } from '@chakra-ui/react'

import { MAX_TAB_SIZE } from '../../config'

interface InfoTabProps extends TabProps {
	title: string
	hint: string
}

export const InfoTab = ({ title, hint, ...props }: InfoTabProps) => {
	return (
		<Tab
			data-wwt-id="room-offer__tab--button"
			_selected={{ color: 'white', bg: 'gray.500' }}
			_hover={{ color: 'gray.500', bg: 'gray.100' }}
			variant="outline"
			border="0.0625rem"
			borderColor="roomOfferTab.border"
			rounded="md"
			py="0.875rem"
			px="1.4375rem"
			textStyle="body-text-5"
			maxH="3rem"
			display="block"
			whiteSpace="nowrap"
			overflow="hidden"
			textOverflow="ellipsis"
			maxW={MAX_TAB_SIZE}
			title={hint}
			_disabled={{
				opacity: 1
			}}
			{...props}
		>
			{title}
		</Tab>
	)
}
